import { colors, focusVisible } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import { OwnerName } from "../../state/authSelectors";
import { SelectedFilePath } from "../../state/files";

const StyledCrumb = styled.button.attrs({ type: "button" })`
  background: none;
  border: none;
  padding: 0.25rem 0.15rem;
  color: ${colors.teal};
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  font-family: ${props => props.theme.font};
  ${focusVisible}
`;

/* the root crumb is a label, not a control — no pointer cursor */
const StyledCrumbLabel = styled.span`
  color: ${colors.teal};
  font-family: ${props => props.theme.font};
`;

function Crumb({ path, pathOnSelect, finalCrumb }: { path: string; pathOnSelect: string[]; finalCrumb: boolean }) {
  const setSelectedFilePath = useSetRecoilState(SelectedFilePath);
  const goToPath = () => {
    setSelectedFilePath(pathOnSelect);
  };

  return (
    <StyledCrumb data-testid={`breadcrumbs-${path}`} onClick={goToPath}>{path}{finalCrumb ? "" : " /"}</StyledCrumb>
  );
}

const StyledCrumbs = styled.div`
  display: flex;
`;

function BreadCrumbs() {
  const selectedFilePath = useRecoilValue(SelectedFilePath);
  const ownerName = useRecoilValue(OwnerName);
  if (!selectedFilePath) {
    return (
      <StyledCrumbs>
        <StyledCrumbLabel>{ownerName}/</StyledCrumbLabel>
      </StyledCrumbs>
    );
  }

  const pathOnSelect: string[] = [];
  const breadCrumbs = selectedFilePath.map((path, idx) => {
    pathOnSelect.push(path);
    const finalCrumb = idx === selectedFilePath.length - 1;
    return <Crumb key={path} path={path} pathOnSelect={[...pathOnSelect]} finalCrumb={finalCrumb} />;
  });

  return <StyledCrumbs>{breadCrumbs}</StyledCrumbs>;
}

export default BreadCrumbs;
